import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
    SoilProfileEditProfileIcon, SoilProfileFieldType
} from '@/resource/IconComponentSets';
import './index.less';
import {
    GetPropertyListResponseModel,
    ISoilProfileExtObjectsResModel,
    ISoilProfileGetLayersDetailResModel,
    ISoilProfileGetSoilDetailResModel,
    IUserManagementSearchModel,
} from '@/util/Request/requestType';
import { Modal, Spin, Table } from 'antd';
import LayerDetailCell from './LayerDetailCell';
import { editOrShowTheSoilProfileModel, ISoilProfileData, updateEstimationMethods, updateFieldTypes, updateObjectType } from '@/redux/reducer/SoilCreatProfiles';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/redux';
import { soilProfileGetMethodList, getUserList, soilProfileGetExtObjects, soilProfileGetFieldType, soilProfileDownLoadProfileDetail } from '@/util/Request';
import { getUserListAction } from '@/redux/reducer/userManagement';
import Download from '../Download';
import GoogleMapReactComponent from '@/components/GoogleMapReact';
import { transformDateToAMorPMFormat } from '@/util/commonFunction';
import TextArea from 'antd/lib/input/TextArea';
import IF from '@/components/IF';

interface IProps {
  deleteCallback?: (deleteId) => void
  editCallback?: (soilProfile) => void
  layerDetail?: ISoilProfileGetLayersDetailResModel[]
  profileDetail?: ISoilProfileGetSoilDetailResModel
  profileDatailSpin?: boolean
  openFromSoilSearch?: boolean
  propertySet?: GetPropertyListResponseModel[]
  readOnly?: boolean
}

export default function SoilProfilePreview(props: IProps) {
    const {
        deleteCallback,
        editCallback,
        layerDetail,
        profileDetail,
        profileDatailSpin = false,
        openFromSoilSearch = false,
        propertySet,
        readOnly = false
    } = props;

    const sampleAndLayerIdsRef = useRef(null);

    const dispatch = useDispatch();

    const [downloadVisible, setDownloadVisible] = useState(false);
    const [fieldTypeString, setFieldTypeString] = useState('');
    const [spining, setSpining] = useState(false);
    const [downloadSpining, setDownloadSpining] = useState(false);

    const { estimationMethods, objectTypes, fieldTypes} = useSelector((state: RootState) => state.soilprofileCreateData);
    const userList = useSelector((state: RootState) => state.userManagemnetPageData.userList);
    const userInfo = useSelector((state: RootState) => state.soilUser.userInfo);

    const superColumns = [
        {
            title: 'Container',
            dataIndex: '',
            key: 'container',
            render: (record) => {
                // Scheme 1
                return (
                    <LayerDetailCell
                        openFromSoilSearch={openFromSoilSearch}
                        propertySet={propertySet}
                        key={record.layerId}
                        layerDetail={record}
                        profileDetail={profileDetail}
                        selectTargetLayerCallback={(sampleId: number, layerId: number) => {
                            sampleAndLayerIdsRef.current = {
                                ...sampleAndLayerIdsRef.current,
                                [layerId]: sampleId
                            };
                        }}
                    />
                );
            }
        },
    ];

    const fetchFieldTypes = useCallback(async() => {
        try {
            if (!fieldTypes.length) {
                const response = await soilProfileGetFieldType();
                response.reverse();
                dispatch(updateFieldTypes(response));
            }
        } catch (err) {
            console.log('err:====', err);
        }
    }, []);

    // if the fieldTypes was undefiened
    useEffect(() => {
        if (fieldTypes.length === 0) {
            fetchFieldTypes();
        }
    }, []);

    useEffect(() => {
        if (profileDatailSpin) {
            sampleAndLayerIdsRef.current = {};
        }
    }, [profileDatailSpin]);

    useEffect(() => {
        if (fieldTypes.length > 0 && !!profileDetail) {
            const fielterResult = fieldTypes.filter((item) => item.fieldTypeId === profileDetail.fieldTypeID);
            if (fielterResult.length > 0) {
                setFieldTypeString(fielterResult[0].fileTypeName);
            }
        }
    }, [fieldTypes, profileDetail]);


    const handleEditProfileButtonClick = async () => {
        try {
            let cacheEstimationMethods = [...estimationMethods];
            if (estimationMethods.length === 0) {
                setSpining(true);
                cacheEstimationMethods = await fetchEstimationMethods();
                dispatch(updateEstimationMethods(cacheEstimationMethods));
                setSpining(false);
            }

            // --------------------------------------select selectPublisher type
            let selectPublisher: IUserManagementSearchModel = {
                key: 'cache',
                userId: profileDetail?.publisherUserID,
                userLoginName: '',
                userDisplayName: profileDetail.publisher,
                userEmail: '',
                userIsActive: '',
                userLastLogin: '',
                roleId: 0,
                roleName: ''
            };
            let filterUserResult;
            if (userList.length === 0) {
                setSpining(true);
                const response = await getUserList({ isGetAllUsers: true });
                filterUserResult = response.filter((user) =>
                    user.userId === profileDetail?.publisherUserID);
                dispatch(getUserListAction({
                    userList: response,
                    downloadUserLists: [],
                    deleteFileBoolean: true,
                    searchUserInformations: [],
                    addUserList: [],
                    sendWelcomeEmailList: [],
                    updateUserList:[]
                }));
                setSpining(false);
            } else {
                filterUserResult = userList.filter((user) =>
                    user.userId === profileDetail?.publisherUserID);
            }

            if (filterUserResult.length > 0) {
                selectPublisher = filterUserResult[0];
            }
            // --------------------------------------select object type
            let selectObjectType: ISoilProfileExtObjectsResModel = {
                externalReferenceId: 0,
                externalReferenceSystem: '',
                externalReferenceObject: '',
                externalReferenceDescription: ''
            };
            let filterResult;
            if (objectTypes.length === 0) {
                setSpining(true);
                const systemSelected = profileDetail.system;
                const objectTypes = await soilProfileGetExtObjects({extSystem: systemSelected});
                dispatch(updateObjectType(objectTypes));
                filterResult = objectTypes.filter((objtype) =>
                    profileDetail.externalReferenceID === objtype.externalReferenceId);
                setSpining(false);
            } else {
                filterResult = objectTypes.filter((objtype) =>
                    profileDetail.externalReferenceID === objtype.externalReferenceId);
            }

            if (filterResult.length > 0) {
                selectObjectType = filterResult[0];
            }
            const data = layerDetail.map((item) => {
                const estimation = cacheEstimationMethods.filter((estimation) => estimation.propertyMeasurementID === item.propMeasurementID);
                return {
                    key: `edit-key-${item.layerId}`,
                    layer: item.layer,
                    rank: item.rank,
                    method: estimation[0],
                    soilAnalysis: item.samples,
                    id: 110,
                    layerID: item.layerId,
                    profileCode: profileDetail.code,
                    profileName: profileDetail.name,
                    status: profileDetail.status,
                    startDepth: item.layerStartDepth,
                    endDepth: item.layerEndDepth
                };
            });
            const profileRequestModel: ISoilProfileData = {
                actionType: 'edit',
                profileid: profileDetail.id,
                name: profileDetail.name,
                // coordinate: `${profileDetail.lat}, ${profileDetail.lng}`,
                coordinate: `${profileDetail.lng}, ${profileDetail.lat}`,
                data,
                // estimationMethods?: ISoilProfilesExtSourceLinkResModel[]
                // objectTypes?: ISoilProfileExtObjectsResModel[]
                selectEcoSystem: profileDetail.system,
                selectObjectType,
                objectID: profileDetail.externalReferenceObjectID,
                desc: profileDetail.description,
                // fieldTypes?: ISoilProfileFieldTypeResModel[]
                selectFieldType: profileDetail.fieldTypeID,
                selectPublisher,
                // contributor?: profileDetail.
                isStandard: false,
                placeName: {
                    geonameId: 0,
                    name: '',
                    countryName: profileDetail.placeName,
                    toponymName: '',
                    adminName: profileDetail.adminName,
                    lat: profileDetail.lat,
                    lng: profileDetail.lng,
                    countryCode: profileDetail.countryCode,
                    alternateNames: [
                        {
                            name: '',
                            lang: ''
                        }
                    ],
                    score: '',
                    adminName1: profileDetail.adminName,
                    adminName2: '',
                    postalcode: '',
                    adminName3: ''
                },
                // show profile detail
                status: profileDetail.status,
                countryName: profileDetail.placeName,
                selectFieldTypeStr: ''
            };

            editCallback && editCallback(profileRequestModel);
            dispatch(editOrShowTheSoilProfileModel(profileRequestModel));
        } catch (err) {
            console.log(err);
        }
    };

    const fetchEstimationMethods = async () => {
        try {
            const estimationMethods = await soilProfileGetMethodList();
            dispatch(updateEstimationMethods(estimationMethods));
            return estimationMethods;
        } catch(err) {
            console.log('err', err);
        }
    };

    const downloadProfile = async (type, sampleLayerObj) => {
        try {
            console.log('sampleLayerObj:=====', sampleLayerObj);
            const layerIdArr = Object.keys(sampleLayerObj);
            const sampleIds = layerIdArr.map((key) => {
                return sampleLayerObj[key];
            });
            const layerIdNumArr = layerIdArr.map((layerIdStr: string) => {
                return parseInt(layerIdStr);
            });
            setDownloadSpining(true);
            if (openFromSoilSearch) {
                let cachePropertyIds: string[] = [];
                if (propertySet && propertySet.length > 0) {
                    cachePropertyIds = propertySet.map(item => {
                        return `${item.id}`;
                    });
                }

                await soilProfileDownLoadProfileDetail(
                    profileDetail.code,
                    profileDetail.name,
                    type,
                    `${profileDetail.code}-${profileDetail.date}.${type}`,
                    layerIdNumArr,
                    sampleIds,
                    cachePropertyIds.join(',')
                );
            } else {
                const date = new Date();
                const yearStr = date.getFullYear();
                const monthStr = date.getMonth();
                const dayStr = date.getDay();
                await soilProfileDownLoadProfileDetail(
                    profileDetail.code,
                    profileDetail.name,
                    type,
                    `${profileDetail.code}-${monthStr}-${dayStr}-${yearStr}.${type}`,
                    layerIdNumArr,
                    sampleIds
                );
            }

            setDownloadSpining(false);
            setDownloadVisible(false);
        } catch(err) {
            console.log('err', err);
            setDownloadSpining(false);
        }
    };

    return (
        <Spin spinning={spining || profileDatailSpin}>
            <div id='soil-preview-container'>
                <div id='over-flow-auto-div'>
                    <div className='soil-preview-info-div'>
                        <div className='preview-info-left-div'>
                            <div className='info-item'>
                                <span>Name</span>
                                <span>{profileDetail && profileDetail.name}</span>
                            </div>
                            <div className='info-item'>
                                <span>Description</span>
                                {/* <Tooltip
                                        overlayStyle={{width: '600px' }}
                                        title={profileDetail && profileDetail.description}
                                    >
                                        <span>
                                            {limitWords(profileDetail && profileDetail.description)}
                                        </span>
                                    </Tooltip> */}
                                <TextArea value={profileDetail && profileDetail.description} readOnly={true}/>
                            </div>
                            <div className='info-item'>
                                <span>Date</span>
                                <span>{profileDetail && profileDetail.date ? transformDateToAMorPMFormat(profileDetail.date, true) : ''}</span>
                            </div>
                            <div className='info-item'>
                                <span>Profile Reference</span>
                                <span>{profileDetail && profileDetail.system || ''}</span>
                            </div>
                            <div className='info-item'>
                                <span>Object Type</span>
                                <span>{profileDetail && profileDetail.extObjectType || ''}</span>
                            </div>
                        </div>
                        <div className='preview-info-right-div'>
                            <div className='info-item'>
                                <span>Coordinates(long,lat)</span>
                                <span>
                                    {profileDetail && profileDetail.countryName},
                                    {profileDetail && profileDetail.adminName},
                                    {profileDetail && profileDetail.lng},
                                    {profileDetail && profileDetail.lat},
                                </span>
                            </div>
                            <div className='info-item'>
                                <span>Field Type</span>
                                <span><SoilProfileFieldType className='field-type-icon' />{fieldTypeString}</span>
                            </div>
                            <div className='info-item'>
                                <span>Status</span>
                                <span>{profileDetail && profileDetail.status}</span>
                            </div>
                            <div className='info-item'>
                                <span>Publisher</span>
                                {/* if not set the publisher user should be set as userDisplayName */}
                                <span>{profileDetail?.publisherUserID || userInfo && userInfo.userDisplayName}</span>
                            </div>
                            <div className='info-item'>
                                <span>Object ID</span>
                                <span>{profileDetail?.externalReferenceObjectID || ''}</span>
                            </div>
                        </div>
                    </div>
                    <div className='soil-analysis-header-div'>
                        <h3>Soil Analysis</h3>
                    </div>
                    <Table
                        columns={superColumns}
                        dataSource={layerDetail}
                        rowKey={(record) => record.layerId}
                        pagination={false}
                        showHeader={false}
                        style={{marginLeft: '-15px'}}
                    />
                    <div className='soil-analysis-header-div'>
                        <h3>Map View</h3>
                    </div>
                    <div>
                        <GoogleMapReactComponent
                            type={'SHOW'}
                            defaultCoordinate={{ lat: profileDetail?.lat, lng: profileDetail?.lng }}
                            defaultZoom={9}
                        />
                    </div>
                </div>
                <div className='operation-div'>
                    <div className='left'>
                        <IF show={(userInfo?.roleName=='Administrator' || (
                            userInfo?.roleName!='Reader'&& (userInfo?.userId==profileDetail?.publisherUserID)
                        )) && !openFromSoilSearch && !readOnly}
                        >
                            <button
                                className='delete-button'
                                onClick={() => deleteCallback && deleteCallback(profileDetail.id)}
                            >
                                    Delete
                            </button>
                        </IF>
                    </div>
                    <div className='right'>
                        <IF show={(userInfo?.roleName=='Administrator' || (
                            userInfo?.roleName!='Reader'&& (userInfo?.userId==profileDetail?.publisherUserID)
                        )) && !openFromSoilSearch && !readOnly}
                        >
                            <button className='edit-button' onClick={() => handleEditProfileButtonClick()}>
                                <SoilProfileEditProfileIcon />
                                <span style={{ marginLeft: '6px' }}>Edit Profile</span>
                            </button>
                        </IF>
                        <button className='download-button' onClick={() => setDownloadVisible(true)}>
                                Download
                        </button>
                    </div>
                </div>
                <Modal
                    open={downloadVisible}
                    onOk={() => setDownloadVisible(false)}
                    onCancel={() => setDownloadVisible(false)}
                    style={{
                        height: 'auto',
                        position: 'absolute',
                        right: '100px',
                        top: '300px',
                    }}
                    className='down-load-modal'
                    title='Choose file format'
                >
                    <Spin spinning={downloadSpining}>
                        <Download
                            titles={['PDF', 'XLS']}
                            className='down-load-div-container'
                            selectSpecifyType={(type) => downloadProfile(type, sampleAndLayerIdsRef.current)}
                            cacncelDownload={() => {
                                setDownloadVisible(false);
                            }}
                        />
                    </Spin>
                </Modal>
            </div>
        </Spin>
    );
}